import { Box, Button, IconButton, Radio, Stack, useTheme } from '@mui/material'
import { connect, useDispatch } from 'react-redux'
import Datepicker from '../../../common/datePicker'
import DropDownOA from '../../../common/dropDownOA'
import { Item } from '../../../common/snippets'
import { SplitButton } from '../../../common/SplitButton'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { RefreshSvg } from '../../../common/svg/refresh'
import { ReportHeading } from '../common/ReportHeading'
import * as id from '../reportId'
import * as lb from '../reportLables'
import { useEffect } from 'react'
import { getBranchList, updateLoader } from '../../../../store/common/common_action'
import { useState } from 'react'
import moment from 'moment/moment'
import { appendToUrl, clickElement, diffInMonths, focusElemnt, getInt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../../common/helper'
import * as url from '../oldReportsUrls'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import EwayReportTable from './EwayReportTable'
import { getEwayBookingReportFilters, getEwayBookingReportTableData } from '../../../../store/reports/reports_action'
import { updateAlertError } from '../../../../store/common/common_action'
import { getCargoRoleRightsConfigListAll } from '../../../../store/common/common_action'
import { urls } from '../../../common/constants'
import { GetRequest } from '../../../common/api'
import { partATblDefs, partATblDefsForBoth, partATblDefsFormattedLRNO, partBTblDefs, partBTblDefsForBoth, partBTblDefsFormattedLRNO, summaryTblDefs } from './const'
const EwayBookingReport = (props) => {
  const {
    data: { common, reports },
    getEwayBookingReportFilters, getEwayBookingReportTableData, updateAlertError, getCargoRoleRightsConfigListAll
  } = props
  const dispatch = useDispatch()
  const { ewayBookingFilter, ewayBookingTableData } = reports
  const { loginData, roleRights, companySettings } = common
  const UseFormattedLRinReports = companySettings?.[0]?.UseFormattedLRinReports || 0
  const EwaybillReportPortrait = companySettings?.[0]?.IsEwaybillReportPortrait || 0
  const reportName = 'Eway Bills'
  const [bookingCity, setBookingCity] = useState('')
  const [bookingCityId, setBookingCityId] = useState('')
  const [destinationCity, setDestinationCity] = useState('')
  const [destinationCityId, setDestinationCityId] = useState('')
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [bookingBranchName, setBookingBranchName] = useState('')
  const [bookingBranchId, setBookingBranchId] = useState('')
  const [destinationBranchName, setDestinationBranchName] = useState('')
  const [destinationBranchId, setDestinationBranchId] = useState('')
  const [selectedRadio, setSelectedRadio] = useState('Booking')
  const [reportViewId, setReportViewId] = useState(0)
  const [reportViewName, setReportViewName] = useState('Part A & B')
  const [companyDropdown, setCompanyDropdown] = useState([])
  const [companyId, setCompanyId] = useState('');
  const [companyName, setCompanyName] = useState('')
  const [bkngCityList, setBkngCityList] = useState([])
  const [bkngBranchList, setBkngBranchList] = useState([])
  const [destCityList, setDestCityList] = useState([])
  const [destBranchList, setDestBranchList] = useState([])


  const theme = useTheme()
  const { palette: cs } = theme

  const reportViewList = [{ id: 0, label: 'Part A & B' }, { id: 1, label: 'Part A' }, { id: 2, label: 'Part B' }]
  const [showTable, setShowTable] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false)
  const criteriaHeaders = [
    { field: 'companyName', header: 'Company', textAlign: 'left' },
    { field: 'fromDate', header: 'From Booking Date', textAlign: 'left' },
    { field: 'toDate', header: 'To Booking Date', textAlign: 'left' },
    { field: 'bookingCity', header: 'Source City', textAlign: 'left' },
    { field: 'bookingBranchName', header: 'Source Branch', textAlign: 'left' },
    { field: 'destinationCity', header: 'Destination City', textAlign: 'left' },
    { field: 'destinationBranchName', header: 'Destination Branch', textAlign: 'left' },
    { field: 'reportViewName', header: 'Report View', textAlign: 'left' },
  ]
  const criteriaData = {
    companyName: companyName || '',
    fromDate: moment(fromDate).format('DD-MMM-YYYY') || '',
    toDate: moment(toDate).format('DD-MMM-YYYY') || ``,
    bookingCity: bookingCity || '',
    bookingBranchName: bookingBranchName || '',
    destinationCity: destinationCity || '',
    destinationBranchName: destinationBranchName || '',
    reportViewName: reportViewName || '',
    dataType: 'entry',
  }
  const partATblColDefs = UseFormattedLRinReports === 0 || UseFormattedLRinReports === 1 ? partATblDefs : UseFormattedLRinReports === 2 ? partATblDefsFormattedLRNO : partATblDefsForBoth
  const partBTblColDefs = UseFormattedLRinReports === 0 || UseFormattedLRinReports === 1 ? partBTblDefs(EwaybillReportPortrait) : UseFormattedLRinReports === 2 ? partBTblDefsFormattedLRNO(EwaybillReportPortrait) : partBTblDefsForBoth(EwaybillReportPortrait)

  useEffect(() => {
    if (!isEmpty(roleRights) && !isEmpty(loginData)) {
      setDisableBtn(!(roleRights?.Table1?.[0]?.AllowViewAllBranchReport || roleRights?.Table1?.[0]?.AllowBranchInchargeRights || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin || loginData?.IsAdmin))
      // setDisableExcel(!(roleRights?.Table1?.[0]?.AllowExportExcel))
    }
  }, [roleRights, loginData])
  useEffect(() => {
    focusElemnt('isCrossingRadioYes')
  }, [])
  useEffect(() => {
    getCargoRoleRightsConfigListAll(loginData, true, 24 * 60 * 60 * 1000)
  }, [loginData])
  useEffect(() => {
    if (ewayBookingFilter?.length > 0) {
      var bkngCity = [{ id: 0, name: 'All' }]
      ewayBookingFilter.map(function (obj) {
        bkngCity.push({
          id: obj.SourceCityID,
          name: obj.SourceCity,
        })
      })
      bkngCity = removeDuplicatesFromArray(bkngCity, `id`)
      setBkngCityList(bkngCity)
      if (bkngCity?.length) {
        const selectedCity = bkngCity?.filter((val) => val.id === loginData?.intBranchCityID)
        if (selectedCity?.length > 0) {
          setBookingCity(selectedCity?.[0]?.name)
          setBookingCityId(selectedCity?.[0]?.id)
        } else {
          setBookingCity(bkngCity[0].name)
          setBookingCityId(bkngCity[0].id)
        }
      }

      var bkngBranch = [{ id: 0, name: 'All' }]
      ewayBookingFilter.map(function (obj) {
        bkngBranch.push({
          id: obj.SourceBranchID,
          name: obj.SourceBranch,
          srcCityId: obj.SourceCityID
        })
      })
      bkngBranch = removeDuplicatesFromArray(bkngBranch, `id`)
      setBkngBranchList(bkngBranch)
      if (bkngBranch?.length) {
        const selectedBranch = bkngBranch?.filter((val) => val.id === loginData?.intBranchID)
        if (selectedBranch?.length > 0) {
          setBookingBranchName(selectedBranch?.[0]?.name)
          setBookingBranchId(selectedBranch?.[0]?.id)
        } else {
          setBookingBranchName(bkngBranch[0]?.name)
          setBookingBranchId(bkngBranch[0]?.id)
        }
      }
      var destCity = [{ id: 0, name: 'All' }]
      ewayBookingFilter.map(function (obj) {
        destCity.push({
          id: obj.DestinationCityID,
          name: obj.DestinationCity,
        })
      })
      destCity = removeDuplicatesFromArray(destCity, `id`)
      setDestCityList(destCity)
      if (destCity?.length) {
        setDestinationCity(destCity[0]?.name)
        setDestinationCityId(destCity[0]?.id)
      }
      var destBranch = [{ id: 0, name: 'All' }]
      ewayBookingFilter.map(function (obj) {
        destBranch.push({
          id: obj.DestinationBranchID,
          name: obj.DestinationBranch,
          destCityId: obj.DestinationCityID
        })
      })
      destBranch = removeDuplicatesFromArray(destBranch, `id`)
      setDestBranchList(destBranch)
      if (destBranch?.length) {
        setDestinationBranchName(destBranch[0]?.name)
        setDestinationBranchId(destBranch[0]?.id)
      }
    }
  }, [ewayBookingFilter])

  useEffect(() => {
    if (loginData) {
      var company = [{ id: loginData.intCompanyID, name: loginData.strCompanyName }]
      setCompanyDropdown(company);
      setCompanyId(loginData.intCompanyID)
      setCompanyName(loginData.strCompanyName)
    }
  }, [loginData])

  const handleClickGo = () => {
    if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else {
      const obj = {
        CompanyID: loginData.intCompanyID,
        FromDate: fromDate.format('YYYY-MM-DD'),
        ToDate: toDate.format('YYYY-MM-DD'),
        Mode: selectedRadio === 'Booking' ? 1 : 2
      }
      getEwayBookingReportFilters(obj)
    }
  }
  const handleClick1 = () => {
    const diffDays = Math.abs(toDate.diff(fromDate, 'days'))
    const isAllSelected = bookingCityId === 0 || destinationCityId === 0 || bookingBranchId === 0 || destinationBranchId === 0
    if (isAllSelected && diffDays > 15) {
      updateAlertError({ show: true, msg: 'For All selection, date range cannot exceed 15 days', nextId: '' })
    }
    else if (bookingCityId === '' || bookingBranchId === '' || destinationCityId === '' || destinationBranchId === '') {
      updateAlertError({ show: true, msg: 'Please Select The Filter Options ', nextId: '' })
    } else {
      dispatch(updateLoader(true))
      let object = {
        CompanyID: loginData.intCompanyID,
        FromDate: fromDate.format('YYYY-MM-DD'),
        ToDate: toDate.format('YYYY-MM-DD'),
        SourceCityID: bookingCityId,
        SourceBranchID: bookingBranchId,
        DestinationCityID: destinationCityId,
        DestinationBranchID: destinationBranchId,
        Mode: selectedRadio === 'Booking' ? 1 : 2,
        ReportMode: reportViewId
      }
      GetRequest(urls.getEwayBookingData, object).then((res) => {
        if (res.status == 'Success') {
          dispatch(updateLoader(false))
          let Table = res?.Data?.Table?.map((item, index) => ({
            ...item,
            srNo: index + 1,
            dataType: 'entry',
            LRNO: `\u200B${item.LRNO}`,
            FormattedLRNO: `\u200B${item.FormattedLRNO}`,
            srcCityBrnch: item.SoureCity + '\n' + item.SourceBranch,
            destCityBrnch: item.DestinationCity + '\n' + item.DestinationBranch,
            sndrDetails: item.Sender + '\n' + item.SenderMobileNo + '\n' + item.SenderGSTN + '\n' + item.SenderEmailID,
            rcvrDetails: item.RecName + '\n' + item.RecMobileNo + '\n' + item.ReceiverGSTN + '\n' + item.ReceiverEmailID,
            EWBValidity: moment(item.EWBValidity).format('DD-MMM-YYYY'),
          }));
          Table.unshift({ srNo: 'Report View: Eway Bill Part A Generation', dataType: 'subHeader', colSpan: { srNo: 11 }, align: { srNo: 'left' }, });
          const totals = Table
            .filter(row => row.dataType === 'entry')
            .reduce((acc, curr) => {
              acc.Units += Number(curr.Units) || 0;
              acc.Freight += Number(curr.Freight) || 0;
              acc.GoodsValue += Number(curr.GoodsValue) || 0;
              return acc;
            }, { Units: 0, Freight: 0, GoodsValue: 0 });
          Table.push({
            EWBValidity: 'Total',
            dataType: 'total',
            Units: totals.Units,
            Freight: totals.Freight,
            GoodsValue: totals.GoodsValue,
          });
          let Table1 = res?.Data?.Table1?.map((item, index) => ({
            ...item,
            srNo: index + 1,
            dataType: 'entry',
            LRNO: `\u200B${item.LRNO}`,
            FormattedLRNO: `\u200B${item.FormattedLRNO}`,
            srcCityBrnch: item.SoureCity + '\n' + item.SourceBranch,
            destCityBrnch: item.DestinationCity + '\n' + item.DestinationBranch,
            CurrtCityBrnch: item.CurrentCity + '\n' + item.CurrentBranch,
            sndrDetails: item.Sender + '\n' + item.SenderMobileNo + '\n' + item.SenderGSTN + '\n' + item.SenderEmailID,
            rcvrDetails: item.RecName + '\n' + item.RecMobileNo + '\n' + item.ReceiverGSTN + '\n' + item.ReceiverEmailID,
            EwayBillValidity: moment(item.EwayBillValidity).format('DD-MMM-YY'),
            EwayBillNewValidity: moment(item.EwayBillNewValidity).format('DD-MMM-YY'),
          }));
          Table1.unshift({ srNo: 'Report View: Eway Bill Part B Generation', dataType: 'subHeader', colSpan: { srNo: 11 }, align: { srNo: 'left' }, });
          const totals1 = Table1
            .filter(row => row.dataType === 'entry')
            .reduce((acc, curr) => {
              acc.Units += Number(curr.Units) || 0;
              acc.Freight += Number(curr.Freight) || 0;
              acc.GoodsValue += Number(curr.GoodsValue) || 0;
              return acc;
            }, { Units: 0, Freight: 0, GoodsValue: 0 });
          Table1.push({
            Message: 'Total',
            dataType: 'total',
            Units: totals1.Units,
            Freight: totals1.Freight,
            GoodsValue: totals1.GoodsValue,
          });
          let Table2 = res?.Data?.Table2?.map((item, index) => ({
            ...item,
            srNo: index + 1,
            dataType: 'entry',
          }));
          const totals2 = Table2
            .filter(row => row.dataType === 'entry')
            .reduce((acc, curr) => {
              acc.NoofEwayBill += Number(curr.NoofEwayBill) || 0;
              acc.units += Number(curr.units) || 0;
              acc.Freight += Number(curr.Freight) || 0;
              return acc;
            }, { NoofEwayBill: 0, units: 0, Freight: 0 });
          Table2.push({
            srNo: 'Total',
            dataType: 'total',
            NoofEwayBill: totals2.NoofEwayBill,
            units: totals2.units,
            Freight: totals2.Freight,
            align: { srNo: 'left' }
          });
          // setShowTable(true)
          let headers = []
          let reportPayload = {}
          let headers2 = summaryTblDefs.map((a) => ({
            ...a,
            field: a.dataKey,
            align: a.xlCol.dataType === "quantity" ? "right" : "left",
            width: getInt(a.headerSx?.minWidth),
            weight: 80
          }))
          if (reportViewId === 1) {
            headers = partATblColDefs.map((a) => ({
              ...a,
              field: a.dataKey,
              align: a.xlCol.dataType === "quantity" ? "right" : "left",
              width: getInt(a.headerSx?.minWidth),
              weight: 80
            }))
            reportPayload = {
              reportName,
              isMultiTable: true,
              tables: [
                {
                  criteriaHeaders,
                  criteriaData: [criteriaData],
                  tableData: Table,
                  mainHeader: headers,
                  colSpanMarker: "EWBValidity"
                },
                {
                  reportName: "Eway Bill Summary",
                  tableData: Table2,
                  mainHeader: headers2
                }
              ],
            }
          } else if (reportViewId === 2) {
            headers = partBTblColDefs.map((a) => ({
              ...a,
              field: a.dataKey,
              align: a.xlCol.dataType === "quantity" ? "right" : "left",
              width: getInt(a.headerSx?.minWidth),
              weight: 80
            }))
            reportPayload = {
              reportName,
              isMultiTable: true,
              tables: [
                {
                  criteriaHeaders,
                  criteriaData: [criteriaData],
                  tableData: Table1,
                  mainHeader: headers,
                  colSpanMarker: "Message"
                },
                {
                  reportName: "Eway Bill Summary",
                  tableData: Table2,
                  mainHeader: headers2
                }
              ],
            }
          } else {
            headers = partATblColDefs.map((a) => ({
              ...a,
              field: a.dataKey,
              align: a.xlCol.dataType === "quantity" ? "right" : "left",
              width: getInt(a.headerSx?.minWidth),
              weight: 80
            }))
            let headers1 = partBTblColDefs.map((a) => ({
              ...a,
              field: a.dataKey,
              align: a.xlCol.dataType === "quantity" ? "right" : "left",
              width: getInt(a.headerSx?.minWidth),
              weight: 80
            }))

            reportPayload = {
              reportName: "Eway Bills Report",
              isMultiTable: true,
              tables: [
                {
                  criteriaHeaders,
                  criteriaData: [criteriaData],
                  tableData: Table,
                  mainHeader: headers,
                  colSpanMarker: "EWBValidity",
                  serialNokey: 'srNo'
                },
                {
                  tableData: Table1,
                  mainHeader: headers1,
                  serialNokey: 'srNo'
                },
                {
                  reportName: "Eway Bill Summary",
                  tableData: Table2,
                  mainHeader: headers2,
                  serialNokey: 'srNo'
                }
              ],
            }
          }
          const rid = Date.now().toString()
          if (!window.generatedReports) {
            window.generatedReports = {}
          }
          window.generatedReports[rid] = reportPayload
          window.open(`/view-report?rid=${rid}`, "_blank")
        }
      })
      // getEwayBookingReportTableData(object)
      // if (!isEmpty(ewayBookingTableData)) {
      //   setShowTable(true)
      // }
    }
  }
  const handleClick2 = () => {
    let url = url.eWayBookingReport
    const urlData = url.eWayBookingReportParams
    urlData.chk = loginData.BusCrsCheckSum
    urlData.intCompanyId = loginData.intCompanyID
    urlData.FromDate = fromDate.format('YYYY-MM-DD')
    urlData.ToDate = toDate.format('YYYY-MM-DD')
    urlData.intFromCityId = bookingCityId
    urlData.intToCityId = destinationCityId
    urlData.intFromBranchId = bookingBranchId
    urlData.intToBranchId = destinationBranchId
    urlData.FromCity = bookingCity
    urlData.ToCity = destinationCity
    urlData.FromBranch = bookingBranchName
    urlData.ToBranch = destinationBranchName
    urlData.Mode = selectedRadio === 'Booking' ? 1 : 2
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }
  const handleChange = (e) => {
    setSelectedRadio(e.target.value)
    setShowTable(false)
  }
  const handleKeyDown = (e) => {
    if (e.key === ' ') {
      setSelectedRadio(e.target.value)
      setShowTable(false)
      focusElemnt(id.fromDate)
    }
  }

  const getDestCity = () => {
    let newData = []
    if (bookingCityId !== 0) {
      newData = destCityList.filter((item) => item.id !== bookingCityId)
    } else {
      newData = [...destCityList]
    }
    return newData
  }
  const ewayData = {
    loginData,
    fromDate,
    toDate,
    bookingCity,
    bookingBranchName,
    destinationCity,
    destinationBranchName,
    reportViewName,
    companyName,
    ewayBookingTableData,
    selectedRadio,
    roleRights
  }
  document.addEventListener('keydown', function (event) {
    const key = event.key.toLocaleLowerCase()
    if (event.altKey && key === 'q') {
      document.getElementById('isCrossingRadioYes').focus();
    }
  });
  return (
    <>
      <Item className="reports" sx={{ padding: '0' }}>
        <ReportHeading reportName={reportName} />
        <Box sx={{ ...sx.reportFlex, justifyContent: 'start', flexWrap: 'nowrap' }}>
          <Item sx={{ ...sx.itemsxGrow, width: '25.3%' }}>
            <DropDownOA id={id.selectCompnay}
              label={lb.select_company}
              searchPlaceholder={'Search Company Name'}
              defaultvalue={companyName || ''}
              value={companyName || ''}
              onClick={() => {
                setShowTable(false)
              }}
              data={companyDropdown || []}
              disabled={true}
              width={'100%'}
              dataKey={`name`}
              idKey={`id`}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <Button
              variant="contained"
              id='ewayBkngGoBtnOne'
              style={{ ...sx.fullHeight, ...sx.novp }}
              className="btn btn-primary"
              //onClick={()=>{}}
              disabled
            >
              GO
            </Button>
          </Item>
          <Box sx={sx.itemsx} style={{ display: 'flex', flexDirection: 'column', marginTop: '-10px', marginLeft: '-10px', marginRight: '5px', width: '11%' }}>
            <label htmlFor={'isCrossingRadioYes'} style={{ marginBottom: '-12px', fontFamily: 'Roboto', fontSize: '12px', fontWeight: '500', color: '#444444' }}>
              <Radio
                id={'isCrossingRadioYes'}
                name={`isCrossingRadio`}
                size={'medium'}
                value="Booking"
                checked={selectedRadio === 'Booking'}
                onChange={handleChange}
                onKeyDown={(e) => handleKeyDown(e)}
              />
              Booking Date Wise
            </label>
            <label htmlFor={'isCrossingRadioNo'} style={{ marginBottom: '-10px', marginLeft: '2px', fontSize: '12px', fontFamily: 'Roboto', fontWeight: '500', color: '#444444' }}>
              <Radio
                id={'isCrossingRadioNo'}
                name={`isCrossingRadio`}
                size={'medium'}
                value="Dispatch"
                checked={selectedRadio === 'Dispatch'}
                onChange={handleChange}
                onKeyDown={(e) => handleKeyDown(e)}
              />
              Dispatch Date Wise
            </label>
          </Box>
          <Item sx={{ ...sx.itemsxGrow, width: '25.3%' }} className="input--container bookingDatePicker">
            <Datepicker
              label='Select From Date'
              id={id.fromDate}
              dateChange={(date) => {
                setFromDate(date)
                focusElemnt(id.toDate)
                setShowTable(false)
              }}
              width="100%"
            />
          </Item>
          <Item sx={{ ...sx.itemsxGrow, width: '25.3%' }} className="input--container bookingDatePicker">
            <Datepicker
              label='Select To Date'
              id={id.toDate}
              dateChange={(date) => {
                setToDate(date)
                focusElemnt('ewayArrowBtn')
                setShowTable(false)
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx}>
            <IconButton
              id="ewayArrowBtn"
              style={{ background: cs.secondary.main, borderRadius: '6px' }}
              onClick={handleClickGo}
              onKeyDown={(e) => {
                navigation3(e, id.bookingCity, 'isCrossingRadioYes', () => { handleClickGo() })
              }}
            >
              <KeyboardArrowRightIcon sx={{ color: cs.white.main }} style={{ fontSize: '25px', margin: '0 10px' }} />
            </IconButton>
          </Item>
        </Box>

        <Box sx={{ ...sx.reportFlex, justifyContent: 'start', flexWrap: 'nowrap' }}>
          <Item sx={{ ...sx.itemsx, width: '15.2%' }}>
            <DropDownOA
              id={id.bookingCity}
              label={'Booking City'}
              data={bkngCityList || []}
              width="100%"
              defaultvalue={bookingCity || ''}
              value={bookingCity || ''}
              searchPlaceholder={`Search City Name`}
              dataKey={`name`}
              disabled={disableBtn}
              idKey={`id`}
              onSelect={(e) => {
                setBookingCity(e.name)
                setBookingCityId(e.id)
                setShowTable(false)
              }}
              nextId={id.bookingBranch}
              prevId={'ewayArrowBtn'}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, width: '15.2%' }}>
            <DropDownOA
              id={id.bookingBranch}
              label={'Booking Branch'}
              data={bkngBranchList.filter((val) => val.srcCityId === bookingCityId || bookingCityId === 0 || val.id === 0) || []}
              width="100%"
              defaultvalue={bookingBranchName || ''}
              value={bookingBranchName || ''}
              searchPlaceholder={'Search Branch Name'}
              disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
              dataKey={`name`}
              idKey={`id`}
              onSelect={(e) => {
                setBookingBranchName(e.name)
                setBookingBranchId(e.id)
                setShowTable(false)
              }}
              nextId={id.destCity}
              prevId={id.bookingCity}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, width: '15.2%' }}>
            <DropDownOA
              id={id.destCity}
              label={'Destination City'}
              data={getDestCity()}
              defaultvalue={destinationCity || ""}
              value={destinationCity || ""}
              width="100%"
              searchPlaceholder={`Search City Name`}
              dataKey={`name`}
              idKey={`id`}
              onSelect={(e) => {
                setDestinationCity(e.name)
                setDestinationCityId(e.id)
                setShowTable(false)
              }}
              nextId={id.destBranch}
              prevId={id.bookingBranch}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, width: '15.2%' }}>
            <DropDownOA
              id={id.destBranch}
              label={'Destination Branch'}
              data={destBranchList?.filter((val) => val.destCityId === destinationCityId || destinationCityId === 0 || val.id === 0) || []}
              width="100%"
              defaultvalue={destinationBranchName || ''}
              value={destinationBranchName || ''}
              searchPlaceholder={'Search Branch Name'}
              dataKey={`name`}
              idKey={`id`}
              onSelect={(e) => {
                setDestinationBranchName(e.name)
                setDestinationBranchId(e.id)
                setShowTable(false)
              }}
              nextId={'ewayReportView'}
              prevId={id.destCity}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, width: '15.2%' }}>
            <DropDownOA
              id={'ewayReportView'}
              label={'Report View'}
              data={reportViewList || []}
              width="100%"
              defaultvalue={reportViewName || ''}
              value={reportViewName || ''}
              searchPlaceholder={'Search Report View'}
              dataKey={`label`}
              idKey={`id`}
              onSelect={(value) => {
                setReportViewId(value.id)
                setReportViewName(value.label)
                setShowTable(false)
              }}
              nextId={'ewaySplitBtnContainer'}
              prevId={id.destCity}
            />
          </Item>
          <Item sx={sx.itemsx} tabIndex={0}
            onKeyDown={(e) => navigation3(e, showTable ? roleRights?.Table1[0]?.AllowExportExcel === 1 ? 'eway-table-xls-button' : 'ewayExportAsPdfBtn' : 'isCrossingRadioYes', 'ewayReportView', () => handleClick1())}
          >
            <SplitButton
              options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
              hideToggle={false}
              onClick1={() => { handleClick1() }}
              onClick2={handleClick2}
              id1={'ewaySplitBtnContainer'}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, display: 'none' }}>
            <RefreshSvg />
          </Item>
        </Box>
        {/* <Box>
          {showTable && <EwayReportTable EwaybillReportPortrait={EwaybillReportPortrait} reportViewId={reportViewId} data={ewayData} UseFormattedLRinReports={UseFormattedLRinReports} />}
        </Box> */}
      </Item>
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getBranchList, getEwayBookingReportFilters, getEwayBookingReportTableData, updateAlertError, getCargoRoleRightsConfigListAll }
export default connect(mapStateToProps, mapDispatchToProps)(EwayBookingReport)
